/* ==========================================================================
   Vapor Space 2.0 — menu
   --------------------------------------------------------------------------
   Desktop mega panels and the mobile navigation drawer.
   ========================================================================== */

(function () {
  'use strict';

  var VS = (window.VS = window.VS || {});

  /* --- Desktop mega panels -----------------------------------------------
     Click to open, not hover-only. A hover-only mega menu is unusable by
     touch and hostile on a trackpad — the panel appears under the pointer on
     the way to something else. Hover is layered on top as an affordance for
     mouse users, with a close delay so crossing the gap between the trigger
     and the panel does not dismiss it. */

  var openPanel = null;
  var closeTimer = null;

  function panelFor(item) {
    return item.querySelector('[data-vs-menu-panel]');
  }

  function triggerFor(item) {
    return item.querySelector('[aria-expanded]');
  }

  function openMega(item) {
    if (openPanel && openPanel !== item) closeMega(openPanel);

    var panel = panelFor(item);
    var trigger = triggerFor(item);
    if (!panel) return;

    clearTimeout(closeTimer);
    panel.hidden = false;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    openPanel = item;
  }

  function closeMega(item) {
    var panel = panelFor(item);
    var trigger = triggerFor(item);
    if (!panel) return;

    panel.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (openPanel === item) openPanel = null;
  }

  function closeAllMega() {
    if (openPanel) closeMega(openPanel);
  }

  VS.$$('[data-vs-menu-item]').forEach(function (item) {
    var trigger = triggerFor(item);
    if (!trigger) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (openPanel === item) closeMega(item);
      else openMega(item);
    });

    item.addEventListener('mouseenter', function () {
      // Only take over on a real pointer. On touch, mouseenter fires
      // alongside the tap and would fight the click handler.
      if (!window.matchMedia('(hover: hover)').matches) return;
      clearTimeout(closeTimer);
      openMega(item);
    });

    item.addEventListener('mouseleave', function () {
      if (!window.matchMedia('(hover: hover)').matches) return;
      closeTimer = setTimeout(function () {
        closeMega(item);
      }, 180);
    });

    // Tabbing out of the panel entirely should close it. Checked on the next
    // frame because during a tab, focus is briefly on <body>.
    item.addEventListener('focusout', function () {
      requestAnimationFrame(function () {
        if (!item.contains(document.activeElement)) closeMega(item);
      });
    });
  });

  document.addEventListener('click', function (e) {
    if (openPanel && !openPanel.contains(e.target)) closeAllMega();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPanel) {
      var trigger = triggerFor(openPanel);
      closeAllMega();
      if (trigger) trigger.focus();
    }
  });

  /* --- Mobile navigation drawer ------------------------------------------- */

  VS.on('click', '[data-vs-menu-open]', function (e, trigger) {
    e.preventDefault();
    var nav = document.getElementById('vs-mobile-nav');
    if (nav) VS.Overlay.open(nav, trigger);
  });

  /* Collapsible groups inside the mobile drawer. Uses <details>/<summary> in
     the markup, so this only handles the accordion behaviour of keeping one
     group open at a time — the open/close itself is native and works with no
     JavaScript at all. */
  VS.on('toggle', '[data-vs-nav-group]', function (e, group) {
    if (!group.open) return;
    VS.$$('[data-vs-nav-group]').forEach(function (other) {
      if (other !== group) other.open = false;
    });
  });

  /* --- Mobile tab bar -----------------------------------------------------
     Hides on scroll down, returns on scroll up. It occupies real estate on a
     small screen and the catalogue is long; getting it out of the way while
     someone is scrolling a collection is worth more than permanent presence.
     Reduced motion keeps it pinned rather than sliding. */

  var tabBar = document.getElementById('vs-tab-bar');
  if (tabBar) {
    var lastY = window.scrollY;
    var ticking = false;

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(function () {
          var y = window.scrollY;
          var goingDown = y > lastY && y > 120;

          tabBar.classList.toggle('is-hidden', goingDown);
          lastY = y;
          ticking = false;
        });
      },
      { passive: true }
    );
  }
})();
